import mapKnownValues from "@/utils/mapKnownValues";
import Station from "@/classes/station";
import Address from "@/classes/address";

export const utilityValues = [
  { key: "LADWP", name: "LADWP" },
  { key: "SCE", name: "SCE" },
  { key: "NVENERGY", name: "NVENERGY" },
  { key: "TEP", name: "TEP" },
  { key: "SDGE", name: "SDGE" },
  { key: "MID", name: "MID" },
  { key: "SRP", name: "SRP" },
  { key: "SMUD", name: "SMUD" },
  { key: "RMP", name: "RMP" },
  { key: "APU", name: "APU" },
  { key: "SVCE", name: "SVCE" },
  { key: "PGE", name: "PG&E" },
  { key: "BWP", name: "BW&P" },
  { key: "PWP", name: "PW&P" },
  { key: "GWP", name: "GWP" }
].sort((a, b) => a.key.localeCompare(b.key));

export type PropertyAPIResponse = {
  id: string;
  oKey: string;
  kwSoftLimit: number;
  manager: string;
  name: string;
  phone: string;
  email: string;
  propertyType: string | null;
  utility: string | null;
  gatewayType: string | null;
  carrierName: string | null;
  hasEditablePenalty: boolean;
  managedAccountId: string | null;

  // address fields
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  latitude: string;
  longitude: string;
  note: string;
};

export default class Property {
  id = "";
  oKey = "";
  kwSoftLimit = 100;
  manager = "";
  name = "";
  phone = "";
  email = "";
  propertyType: null | string = null;
  utility: null | string = null;
  gatewayType: null | string = null;
  carrierName: null | string = null;
  hasEditablePenalty = false;
  managedAccountId: null | string = null;

  // Address information
  address1 = "";
  address2 = "";
  city = "";
  state = "";
  zip = "";
  latitude = "";
  longitude = "";
  note = "";

  // Custom Properties
  stations: Station[] = [];

  constructor(params: Partial<Property> = {}) {
    mapKnownValues(this, params);
  }

  get address() {
    return new Address(this);
  }

  toJson() {
    return {
      ...this,
      stations: undefined
    };
  }

  static fromAPI(response: PropertyAPIResponse, stations: Station[] = []) {
    return new Property({
      ...response,
      stations
    });
  }
}
